import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { GetDesign } from '../../../../store/UserThemes/design.action';
import { NSLoginService } from '../../Services/NSLogin.service';
import { LucideAngularModule } from 'lucide-angular';
import { NSAdminService } from '../../Services/NSAdmin.service';
import { CompanyRole } from '../../Models/admin-model';
import { CommonModule } from '@angular/common';
import { StorageService } from '../../../../core/services/storage-service.service';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'NS-headermenu',
  standalone: true,
  imports: [RouterLink, LucideAngularModule, CommonModule, MatTooltipModule],
  templateUrl: './NS-headermenu.component.html',
  styleUrl: './NS-headermenu.component.scss',
})
export class NSHeadermenuComponent implements OnInit {
  roles: CompanyRole[] = [];
  menuList: any[] = [];
  parentMenus: any[] = [];
  isSearchOpen: boolean = false;
  isMobileMenuOpen: boolean = false;
  username: string = "";
  constructor(
    private loginser: NSLoginService,
    private adminService: NSAdminService,
    private storage: StorageService,
    private router: Router

  ) { }

  ngOnInit(): void {
    this.username = this.storage.getLocal('username') || "";
    this.loadMenus();

  }

  loadMenus() {
    this.adminService.GetCompanyMenus().subscribe((menus: any[]) => {
      const filteredMenus = menus.filter((m) => m.isMenu === true);
      const filteredsubMenus = menus.filter((m) => m.isMenu === false && m.sequenceId == -1);
      filteredMenus.sort((a, b) => a.sequenceId - b.sequenceId);
      this.parentMenus = filteredMenus.filter((m) => m.parentId === 0);
      this.parentMenus.forEach((parent) => {
        parent.children = filteredMenus
          .filter((child) => child.parentId === parent.menuId)
          .sort((a, b) => a.sequenceId - b.sequenceId);
      });
      let children = this.parentMenus.flatMap(item => item.children);
      children.push(...filteredsubMenus);
      this.storage.setSession('menulist', children);
    });
  }

  navigateOrReload(url: string) {
    if (this.router.url === "/" + url) {
      window.location.reload();
    } else {
      this.router.navigateByUrl(url);
    }
  }

  logoutuser() {
    this.loginser.logout();
  }
  getsession() {
    return this.loginser.RemainingTime$.value;
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  toggleSearch(): void {
    this.isSearchOpen = !this.isSearchOpen;

    if (this.isSearchOpen) {
      setTimeout(() => {
        this.searchInput?.nativeElement.focus();
      });
    }
  }
}
